import React from "react";
import { BookOpenIcon, BrainIcon, ClockIcon, CompassIcon, NotebookPenIcon, ShuffleIcon } from "lucide-react";
import { painPoints } from "../../data/content";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
const iconMap: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  compass: CompassIcon,
  clock: ClockIcon,
  shuffle: ShuffleIcon,
  book: BookOpenIcon,
  brain: BrainIcon,
  notebook: NotebookPenIcon
};
export function PainPoints() {
  return <section className="bg-cream px-5 py-16 md:py-24" data-id="element-246" data-mp="2ckltzjq41312">
      <div className="mx-auto max-w-5xl" data-id="element-247" data-mp="2ql6h2s325l0d">
        <SectionHeading eyebrow="If you're a plastic surgeon or aesthetic physician" title={<>
              You may recognize <em className="italic text-gold-dark" data-id="element-249" data-mp="w75hu63livzr">this…</em>
            </>} data-id="element-248" data-mp="2qjvbcmq1y36m" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-250" data-mp="s5jvzv9337df">
          {painPoints.map(p => {
          const Icon = iconMap[p.icon];
          return <li key={p.title} className="flex gap-4 rounded-2xl border border-navy/10 bg-white p-5 md:p-6" data-id="element-251" data-mp="1n9efzx2yb0a0">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-alert/10 text-alert" data-id="element-252" data-mp="1s765ylk1ccbk">
                  <Icon className="h-5 w-5" data-id="element-253" data-mp="1x3wpjiv1tq1q" />
                </span>
                <div data-id="element-254" data-mp="21xhnjawn6k0x">
                  <p className="text-[17px] font-bold leading-snug text-navy" data-id="element-255" data-mp="21ysqx9m6dpri">{p.title}</p>
                  <p className="mt-2 text-[15px] leading-relaxed text-navy/70" data-id="element-256" data-mp="26vj6lvu2ijce">{p.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-navy/80 md:text-lg" data-id="element-257" data-mp="2fxinmo531nfc">
          <p data-id="element-258" data-mp="2kv24lvt60eaz">And it shouldn't have to feel so disorganized.</p>
          <p data-id="element-259" data-mp="lj9dugwz056p">Because the problem isn't necessarily a lack of knowledge.</p>
          <p className="font-serif text-2xl font-black text-navy md:text-3xl" data-id="element-260" data-mp="qhj5wineepo3">
            It's often a lack of <em className="italic text-gold-dark" data-id="element-261" data-mp="iglcqsa2vcma">structured case practice.</em>
          </p>
          <p data-id="element-262" data-mp="ef9l6h7n8hbg">That's exactly why I created The Abdominoplasty Master System™.</p>
        </div>

        <SectionCta label="I want a structured case system" data-id="element-263" data-mp="ehm7t7ocjfuu" />
      </div>
    </section>;
}